import ErrorIndicator from "@/shared/components/error-indicator/index.vue";
import LoadingIndicator from "@/shared/components/loading-indicator/index.vue";
import { TrustAPI } from "@/shared/modules/trust-api";
import { InvestigationView, NoteView, PracticeRisk, PracticeRiskIndicator, PracticeView } from "@/shared/modules/typescript-trustapi-client/models";
import store from "@/trust-admin-app/store";
import { Inject, Options, Vue, Watch } from "vue-property-decorator";
import AddEditModal from "./add-edit-modal/index.vue";
import FormatDateTimeMixin from '@/shared/mixins/format-datetime';
import { EventEmitter } from "events";
import { orderBy } from "lodash";
import { AppInsights } from "@/trust-investigator-app/appInsights";

@Options({
  components: {
    AddEditModal,
    ErrorIndicator,
    LoadingIndicator
  },
  mixins: [FormatDateTimeMixin]
})
export default class PracticeNotes extends Vue {
  private ai = new AppInsights;

  @Inject({ from: 'apiService', default: new TrustAPI() })
  private apiService!: TrustAPI;

  @Inject({ from: 'practiceRisks', default: [] })
  private practiceRisks!: PracticeRisk[];

  @Inject({ from: 'practiceRiskIndicators', default: [] })
  private practiceRiskIndicators!: PracticeRiskIndicator[];

  private showRiskNote = false;

  @Watch('showRiskNote')
  private onShowRiskNoteChange() {
    this.getNotes();
  }

  private loadingContent = false;
  private errorLoadingContent = false;
  private investigations: InvestigationView[] = [];

  private notesHeadings = [
    { text: 'Date', value: 'date', sortable: false },
    { text: 'Notes', value: 'notes', sortable: false }
  ];

  private notes: NoteView[] = [];

  private showAddEditModal = false;

  created(): void {
    this.getNotes();
  }

  mounted() {
    window.scrollTo(0, 0);
    this.eventCtrl.on('reload-practice-notes', this.getNotes);
  }

  beforeUnmount() {
    this.eventCtrl.off('reload-practice-notes', this.getNotes);
  }

  private async getNotes(): Promise<void> {
    try {
      this.loadingContent = true;
      this.errorLoadingContent = false;

      const resp: any = await this.apiService.NotesApi?.apiV2NotesGetNotesByPracticeIdPost(
        {
          practiceId: this.selectedPractice.id,
          showRiskOnly: this.showRiskNote
        }
      );

      this.notes = resp.data.data;
      this.notes = orderBy(
        this.notes,
        ['id', 'createdOn'],
        ['asc', 'desc']
      );

    } catch {
      this.errorLoadingContent = true;
    } finally {
      this.loadingContent = false;
    }
  }

  get selectedPractice(): PracticeView {
    return store.getters.getSelectedPractice;
  }

  get eventCtrl(): EventEmitter {
    return store.getters.getEventController;
  }

  private async showInvestigationDetails(n: InvestigationView) {
    await this.apiService.InvestigationApi?.apiV2InvestigationGetInvestigationsByPracticeIdPracticeIdGet(
      this.selectedPractice.id
    )
      .then(res => {
        this.investigations = res.data.data;
        const _inv: InvestigationView[] = this.investigations.filter(i => {
          return i.id = n.id;
        });
        if (_inv.length > 0)
          this.eventCtrl.emit('showInvestigationDetailsModal', _inv[0]);
      })
      .catch(err => {
        this.ai.trackException('Unable to get Investigation details: ' + err);
        this.eventCtrl.emit('show-snackbar', 'error', 'Unable to get Investigation details: ' + err.message);
        console.log(err);
      })
  }

}

